// extracted by mini-css-extract-plugin
module.exports = {"offer-hero":"OfferHeroView_offer-hero__C73th","title":"OfferHeroView_title__dENxB"};